<bmcore-share-track-popup [appType]="'PROD-PAGE'" [colorSettingsMode]="colorSettingsMode"> </bmcore-share-track-popup>
